import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../hooks/CustomHook';
import { getNewsBySlug, getSortedNews, newsCategoryStyle, formatNewsDate } from '../data/news';

const NewsDetail = () => {
    const { slug } = useParams();
    const article = getNewsBySlug(slug);

    useDocTitle(article ? `江西族迹 | ${article.title}` : '江西族迹 | 新闻动态');

    if (!article) {
        return <Navigate to="/news" replace />;
    }

    const { full } = formatNewsDate(article.date);
    const others = getSortedNews().filter((n) => n.slug !== article.slug).slice(0, 3);

    return (
        <>
            <NavBar />
            <main className="bg-[#f4f7fb] min-h-screen text-gray-800">
                <article className="pt-28 md:pt-36 pb-16 md:pb-24">
                    <div className="max-w-3xl mx-auto px-6">
                        <Link to="/news" className="text-sm text-blue-700 hover:text-blue-800 font-medium inline-flex items-center gap-1 mb-8">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                            返回资讯列表
                        </Link>

                        <div className="flex items-center gap-3 mb-5">
                            <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${newsCategoryStyle[article.category] || 'bg-gray-100 text-gray-600'}`}>
                                {article.category}
                            </span>
                            <time className="text-sm text-slate-400">{full}</time>
                        </div>

                        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight mb-6">
                            {article.title}
                        </h1>
                        <p className="text-lg text-slate-600 leading-relaxed mb-10">
                            {article.summary}
                        </p>
                    </div>

                    {article.cover && (
                        <div className="max-w-4xl mx-auto px-6 mb-10">
                            <img
                                src={article.cover}
                                alt={article.title}
                                className="w-full rounded-2xl object-cover max-h-[440px]"
                            />
                        </div>
                    )}

                    <div className="max-w-3xl mx-auto px-6 space-y-5 text-lg text-slate-600 leading-[1.9]">
                        {article.content.map((p, i) => (
                            <p key={i}>{p}</p>
                        ))}
                    </div>

                    {article.photos?.length > 0 && (
                        <div className="max-w-4xl mx-auto px-6 mt-10">
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                {article.photos.map((src, i) => (
                                    <img
                                        key={src}
                                        src={src}
                                        alt={`${article.title} 现场 ${i + 1}`}
                                        loading="lazy"
                                        decoding="async"
                                        className="w-full h-52 sm:h-48 object-cover rounded-xl bg-slate-100"
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </article>

                {others.length > 0 && (
                    <section className="max-w-3xl mx-auto px-6 pb-20 md:pb-28">
                        <h2 className="text-xl font-bold text-slate-900 mb-6">更多动态</h2>
                        <ul className="space-y-3">
                            {others.map((item) => (
                                <li key={item.slug}>
                                    <Link
                                        to={`/news/${item.slug}`}
                                        className="flex items-center justify-between gap-4 bg-white rounded-xl border border-slate-100 px-5 py-4 hover:border-blue-200 hover:shadow-sm transition-all"
                                    >
                                        <span className="font-medium text-slate-800">{item.title}</span>
                                        <span className="text-xs text-slate-400 flex-shrink-0">{formatNewsDate(item.date).full}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </section>
                )}
            </main>
            <Footer />
        </>
    );
};

export default NewsDetail;
